export default {
  brand_meetCenter: "brand_meetCenter",
  brand_meetCenter_edit: "brand_meetCenter_edit",
  brand_meetCenter_add: "brand_meetCenter_add",
  brand_meetCenter_online: "brand_meetCenter_online",
  brand_meetCenter_recommend: "brand_meetCenter_recommend"
};